import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "@/components/feature/AuthContext";
import { ToastProvider } from "@/components/base/Toast";
import { PipelineActivityProvider } from "@/components/feature/PipelineActivityContext";
import { GlobalModalProvider } from "@/components/feature/GlobalModalContext";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <ToastProvider>
          <PipelineActivityProvider>
            <GlobalModalProvider>
              <BrowserRouter basename={__BASE_PATH__}>
                <AppRoutes />
              </BrowserRouter>
            </GlobalModalProvider>
          </PipelineActivityProvider>
        </ToastProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;